export enum ActionButton {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  DETAIL = 'DETAIL',
  MANAGEMENT = 'MANAGEMENT',
}
